const error = document.getElementById('stripe-error');
const errorMessage = document.getElementById('stripe-error-message');

module.exports = {
  setEvent: (elements) => {
    elements.forEach( (element, idx) => {
      element.on('change', onChangeHandler);
    });
  },
  showError: (text) => {
    onShowError(text);
  }
}

const onChangeHandler = (event) => {
  if (event.error) onShowError(event.error.message);
  return error.classList.remove('visible');
}

const onShowError = (text) => {
  error.classList.add('visible');
  errorMessage.innerText = text;
}
